import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosProgressEvent } from 'axios';

import { YpfImportResult } from '../interfaces/ypf';
import ChatService from '../services/chat.service';

/**
 * Tipo para el payload del método `uploadYpfFile`.
 */
interface UploadYpfFilePayload {
    file: File;
    handleProgressEvent?: (event: AxiosProgressEvent & { name: string }) => void;
}

/**
 * Hook para subir un archivo a través del método `uploadYpfFile`.
 *
 * @returns La mutation para subir el archivo.
 */
export const useUploadYpfFile = (): UseMutationResult<YpfImportResult, Error, UploadYpfFilePayload> => {
    return useMutation<YpfImportResult, Error, UploadYpfFilePayload>({
        mutationFn: async ({ file, handleProgressEvent }: UploadYpfFilePayload) => {
            const chatService = new ChatService();
            const response = await chatService.uploadYpfFile(file, handleProgressEvent);
            return response;
        },
    });
};
